import React, { Component } from "react";
import MaterialTable from "material-table";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import CommonLoader from "../loaderComponent/CommonLoader";
import { ThemeProvider } from '@material-ui/core'
import CommonToast from "../Toaster/CommonToast";
import { hasPermission } from "../../utils/usePermission";
import { createTheme } from "@material-ui/core/styles";
import ConfirmModal from "../../utils/ConfirmModal";
import { FaFileAlt, FaHourglassHalf, FaPencilAlt } from "react-icons/fa";
import PurchaseOrderPDF from "../../utils/PurchaseOrderPDF";
import WorkOrderPDF from "../../utils/WOPDF";


export default class WorkOrderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purchaseOrders: [],
      loading: true,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      deleteId: null,
      workOrderPrint: [],
      color: '',
      completed: false
    };
  }

  openConfirmModal = () => {
    this.setState({ showConfirm: true, });
  };
  closeConfirmModal = () => {
    this.setState({ showConfirm: false });
  };

  componentDidMount() {
    this.fetchPurchaseOrders();
  }

  fetchPurchaseOrders = () => {
    this.setState({ loading: true });
    axios
      .get("/workorders")
      .then((res) => {
        this.setState({ purchaseOrders: res.data, loading: false });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error fetching Work Orders",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };

  handleDelete = () => {
    axios
      .delete(`/workorders/${this.state.deleteId}`)
      .then(() => {
        this.setState({
          showToast: true,
          showConfirm: false,
          toastMessage: "Work Order deleted successfully",
          toastVariant: "success",
          color: 'green',
          deleteId: null,
        });
        this.fetchPurchaseOrders();
      })
      .catch((error) => {
        this.setState({
          showToast: true,
          showConfirm: false,
          toastMessage: error.response?.data?.message || "Error deleting Work Order",
          toastVariant: "danger",
          deleteId: null,
          color: 'red'
        });
      });
  };

  handleMoveAdd = () => {
    this.props.history.push('/work-order-add')
  }
  handleEdit = (rowData) => {
    console.log("rowData", rowData);
    const { id } = rowData;
    this.props.history.push(`/work-order-edit/${id}`, { data: rowData });
  };
  handleView = (rowData, viewPage) => {
    // console.log("rowData", rowData);
    const { id } = rowData;
    this.props.history.push(`/work-order-view/${id}`, { data: rowData, viewPage });
  };


  fetchPurchaseOrderPrint = async (id) => {
    this.setState({ loading: true });

    try {
      const res = await axios.get(`/workorders/${id}`);
      console.log("res.data", res.data)
      this.setState({ workOrderPrint: res.data, loading: false, completed: true });
    } catch (error) {

    }
  }

  handlePrint = async (rowData) => {
    console.log("first rowData", rowData);
    const companyInfo = {
      name: rowData.customer.name,
      project: rowData.project.name,
    }
    try {
      await this.fetchPurchaseOrderPrint(rowData.id);
      const logoBase64 = ''
      if (this.state.completed && this.state.workOrderPrint) {
        await WorkOrderPDF.generate(this.state.workOrderPrint, logoBase64, companyInfo);
      }
    } catch (error) {
      console.error('Failed to generate PDF:', error);
      alert('Failed to generate PDF. Please check console for details.');
    }
  };


  render() {
    const { purchaseOrders, loading, showToast, toastMessage, toastVariant } = this.state;
    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })
    return (
      <>
        <CommonToast
          show={showToast}
          onClose={() => this.setState({ showToast: false })}
          message={toastMessage}
          variant={toastVariant}
          color={this.state.color}
        />
        <ConfirmModal
          show={this.state.showConfirm}
          onHide={() => this.setState({ showConfirm: false, deleteId: null })}
          onConfirm={() => this.handleDelete()}
          title="Delete Confirmation"
          message="Are you sure you want to delete this Work Order?"
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <div className='d-flex search-btn-gap'>
              {
                hasPermission('M18B1') && (
                  <div className='add-role'>
                    <Button variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleMoveAdd}> <i className="fa fa-plus-circle"></i> Add Work Order</Button>
                  </div>
                )
              }
            </div>
            <div className="col-sm-12">
              <Card>
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <div className="panel-title">
                    <strong>Work Orders List</strong>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      title="Work Orders"
                      columns={[
                        {
                          title: "ID", field: "id", editable: "never",
                          cellStyle: { minWidth: 100 },
                          headerStyle: { minWidth: 100 }
                        },
                        // {
                        //   title: "WO Date", field: "woDate", type: "date",
                        //   cellStyle: { minWidth: 120 },
                        //   headerStyle: { minWidth: 120 }
                        // },

                        {
                          title: "WO Date",
                          field: "woDate",
                          type: "date",
                          render: rowData => {
                            if (!rowData.woDate) return '';
                            const date = new Date(rowData.woDate);
                            return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
                              .toString()
                              .padStart(2, '0')}/${date.getFullYear()}`;
                          },
                          cellStyle: { minWidth: 100 },
                          headerStyle: { minWidth: 100 }
                        },
                        {
                          title: "Customer", field: "customer.name",
                          cellStyle: { minWidth: 200 },
                          headerStyle: { minWidth: 200 }
                        },
                        {
                          title: "Project", field: "project.name",
                          cellStyle: { minWidth: 200 },
                          headerStyle: { minWidth: 200 }
                        },
                        {
                          title: "Labour Name",
                          field: "labour",
                          render: rowData => rowData.items?.map(item => item.labour?.name).join(", "),
                          cellStyle: { minWidth: 200 },
                          headerStyle: { minWidth: 200 }
                        },
                        {
                          title: "Status", field: "status",
                          cellStyle: { minWidth: 150 },
                          headerStyle: { minWidth: 150 },
                          render: rowData => {
                            const status = rowData?.status;
                            const baseStyle = {
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.875rem',
                              padding: '4px 12px',
                              borderRadius: '20px',
                              fontWeight: 500
                            };

                            if (status === 'pending') {
                              return (
                                <span style={{
                                  ...baseStyle, backgroundColor: '#fff3cd',
                                  color: '#664d03',
                                  border: '1px solid #ffe69c'
                                }}>
                                  <FaHourglassHalf /> Pending
                                </span>
                              );
                            }
                            else {
                              return (
                                <span style={{
                                  ...baseStyle,
                                  backgroundColor: '#f8d7da',
                                  color: '#842029',
                                  border: '1px solid #f5c2c7'
                                }}>
                                  <FaPencilAlt /> Draft
                                </span>
                              );
                            }
                          }

                        },
                        {
                          title: "Total Item Value ", field: "status",
                          cellStyle: { minWidth: 150 },
                          headerStyle: { minWidth: 150 },
                          render: rowData => {
                            const totalValue = (rowData.items || []).reduce((sum, item) => {
                              return sum + (parseFloat(item.totalValue) || 0);
                            }, 0);

                            return `₹ ${totalValue.toFixed(2)}`;
                          }
                        },
                        {
                          title: "Action", field: "status",
                          render: rowData => (
                            <>
                              {/* {console.log("this is rowdata", rowData.status)} */}
                              {rowData.status === "draft" ?
                                <>
                                  {hasPermission('M18B2') && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Edit  Work Order</Tooltip>}
                                    >
                                      <Button size="sm" variant="outline-info" className="mr-2 info"
                                        onClick={() => this.handleEdit(rowData)}
                                      >
                                        <i class="fa fa-edit"></i>
                                      </Button>
                                    </OverlayTrigger>
                                  )}
                                </>
                                : ""}
                              {hasPermission('M18B4') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>View  Work Order</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-info" className="mr-2 info"
                                    onClick={() => this.handleView(rowData, "viewPage")}
                                  >
                                    <i class="fa fa-eye"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                              {hasPermission('M18B3') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Delete Work Order</Tooltip>}
                                >
                                  <Button size="sm" className="mr-2 delete-btn" variant="outline-danger"
                                    onClick={() => this.setState({ showConfirm: true, deleteId: rowData.id })}
                                  // onClick={() => this.handleDelete(rowData.citemid)}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                              {
                                //rowData.status != 'Paid' &&
                                hasPermission('M18B5') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-print-${rowData.id}`}>Print Work Order</Tooltip>}
                                  >
                                    <Button
                                      size="sm"
                                      variant="outline-info"
                                      className="mr-2 info"
                                      onClick={() => this.handlePrint(rowData)}
                                    >
                                      <i className="fa fa-print"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )
                              }
                            </>
                          ),
                          cellStyle: { width: '250px', minWidth: '250px', textAlign: 'center' }, // Adjust width as needed
                          headerStyle: { width: '250px', minWidth: '250px', textAlign: 'center' }
                        },
                      ]}
                      data={purchaseOrders}
                      options={{
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 30, 50, 75, 100],
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        actionsColumnIndex: -1,
                        search: true,
                        paging: true,
                      }}
                    />
                  </ThemeProvider>
                </Card.Body>
              </Card>
            </div>
          </div>
        </CommonLoader>
      </>
    );
  }
}
